import axiosInstanceBuilder from "../../config/axios/axiosInstanceBuilder";
import { mapToEmptyArrayIfNull } from "../../config/axios/utils/mapToEmpyArrayIfNull";
import { useFetch } from "../../config/axios/useFetch";

const baseUrl = process.env.REACT_APP_API_DEV_URL;
const endpoint = encodeURI("/common/languages?return_sorted=true");

const createAxiosPromise = () => {
  return axiosInstanceBuilder(baseUrl).get(endpoint);
};

export const useFindAllLanguages = (callAfterMount = false) => {
  const { data, isPending, error, fetchApi } = useFetch(
    createAxiosPromise,
    callAfterMount
  );

  const findAllLanguages = async () => {
    const response = await fetchApi();
    const { data, ...rest } = response;
    return { languages: mapToEmptyArrayIfNull(data), ...rest };
  };

  return {
    languages: mapToEmptyArrayIfNull(data),
    isLoading: isPending,
    error,
    findAllLanguages,
  };
};
